<template>
  <div style="max-height: 500px;overflow-y: auto">
    <div v-loading="loading" class="rj-page-card" style="padding-top: 0">
      <div class="rj-page-card__content">
        <div class="el-table el-table--fit el-table--border el-table--enable-row-transition el-table--mini" style="width: 100%;">
          <div class="el-table__header-wrapper">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" width="100%">
              <colgroup>
                <col width="20%">
                <col width="40%">
                <col width="40%">
                <col width="120">
                <col width="120">
                <col width="120">
              </colgroup>
              <thead class="has-gutter">
                <tr class="">
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      产品分类
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      商品名称
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      规格型号
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      数量
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class=" is-center is-leaf">
                    <div class="cell">
                      是否购买PSC
                    </div>
                  </th>
                  <th colspan="1" rowspan="1" class="is-center is-leaf">
                    <div class="cell">
                      服务授权分类
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="el-table__body-wrapper is-scrolling-none">
            <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" width="100%">
              <colgroup>
                <col width="20%">
                <col width="40%">
                <col width="40%">
                <col width="120">
                <col width="120">
                <col width="120">
              </colgroup>
              <tbody>
                <template v-for="(productInfos,index) in tableData">
                  <tr :key="index" class="el-table__row">
                    <!--不是组合包的情况-->
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.productCategoryName }}
                      </div>
                    </td>
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.salesProductName }}
                      </div>
                    </td>
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.productName }}
                      </div>
                    </td>
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.productAmount }}
                      </div>
                    </td>
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.buyPsc=='true'?'是':'否' }}
                      </div>
                    </td>
                    <td class="is-center ">
                      <div class="cell">
                        {{ productInfos.productPscType }}
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {
    };
  },
  props: {
    tableData: {
      type: Array,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
  },
  methods: {
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
  @import "../../../../style/var";
  .rj-tabs-body{
    padding: 0 10px;
  }
.proTitle{
  font-size: 15px;
  .label{
    display: inline-block;
  }
  .money{
    color: $--color-danger;
    display: inline-block;
    margin-left: 25px;
  }
}
  .productTable{
    &.el-table::before{
      height: 0;
    }
    tr{
      td{
        border-right: 1px solid $--border-color-light;
        border-bottom: 1px solid $--border-color-light;
        &:last-child{
          border-right:none;
        }
      }
      &:last-child{
        td{
          border-bottom: none;
        }
      }
    }
  }
  .groupTable{
    table-layout: fixed;
    border-collapse: collapse;
    tr{
      td{
        padding: 10px 0;
        border: none;
        &.borderBottom{
          border-bottom: 1px solid $--border-color-light;
        }
      }
      &:last-child{
        td{
          &.borderBottom{
            border: none;
          }
        }
      }
    }
  }
  .groupTableline{
    position: absolute;
    width: 1px;
    height: 100%;
    background: $--border-color-light;
    top: 0;
    left: 50%;
  }
  table,
  table tr
  table tr td,
  table th td{
    word-wrap:break-word
  }
</style>
